<template>
  <div class="loan_item">
    <div class="inner">
      <h3>About Us</h3>
      <!-- <h3>关于我们</h3> -->
      <div class="left_cell">
        <p>Guangzhou Fujin Information Technology Co., Ltd. is a professional overseas technology financial solutions service provider. </p>
        <p>广州复金信息科技有限公司是专业的海外科技金融解决方案服务商。</p>
        <p>Headquartered in Guangzhou, it provides life-cycle products and services for overseas Internet finance industries such as Southeast Asia, India, Africa and South America, focusing on big data wind control intelligent analysis and decision-making, dedicated to building intelligent wind control, financial big data and other financial technology products.</p>
        <p>总部位于广州，为东南亚、印度、非洲、南美等海外互联网金融行业提供全生命周期的产品和服务，专注于大数据风控智能分析与决策，致力于建设智能风控、金融大数据等金融科技产品。</p>
        <p>Company executive team mainly from Ali, Baidu, Tencent and other well-known enterprises at home and abroad, in technology research and development, AI intelligence, big data wind control and product operation with rich experience and advantages.</p>
        <p>公司高管团队主要来自阿里、百度、腾讯等海内外知名企业，在技术研发、AI智能、大数据风控以及产品运营领域具有丰富实战经验和优势。</p>
        <!-- <p>Micro Loan is your one-stop online loan platform, it is an online lending marketplace that offers customers a wide range of options based on big data analysis.</p>
        <p>Our partnership spans some of the best loan providers in India who provide their services through mobile apps.</p>
        <p>Micro Loan acts as the bridge between loan providers and customers through technology. We rely on big data analysis to understand customer needs and recommend suitable financial products to them.</p>
        <p>We enable our users to get quick, easy, and reliable loan services without the need for branch visits. Our application process is 100% online.Empower yourself with anytime-anywhere loan access.</p> -->
      </div>
      <div class="right_cell">
        <img src="@/assets/images/loanImg/bn_n.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.loan_item{
  .inner{
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
    h3{
      font-size: 36px;
      color: #333333;
    }
    .left_cell{
      float: left;
      width: 50%;
      padding: 60px 0;
      p{
        font-size: 16px;
        line-height: 30px;
        color: #999999;
      }
      ul{
        padding-top: 60px;
        li{
          float: left;
          width: 188px;
          height: 132px;
          padding-top: 50px;
          text-align: center;
          font-size: 16px;
          border-radius: 4px;
          border: 1px solid #f1f1f1;
          color: #333333;
          box-shadow: 0px 1px 10px 1px #f1f1f1;
          margin-right: 40px;
          margin-left: 5px;
        }
      }

    }
    .right_cell{
      float: left;
      width: 50%;
      padding: 60px 0;
      img{
        width: 560px;
      }

    }
  }

}
</style>
